import {BrowserRouter as Router, Switch, Route,} from 'react-router-dom';
import {routes} from "./routes/routes";
import SettingsView from "./views/SettingsView";
import PageNotFoundView from "./views/PageNotFoundView";
import ScenariosView from "./views/ScenariosView";
import ReportsView from "./views/ReportsView";
import DashboardView from "./views/HomeView";
import ScenarioView from "./views/ScenarioView";
import LoginView from "./views/LoginView";
import PrivateRoute from "./PrivateRoute";
import Layout from "./components/layout/Layout";
import {ModalProvider} from "./components/modal/useModal";
import ResetView from "./views/ResetView";
import OnRouteChange from './util/OnRouteChange';
import LoggingView from './views/LoggingView';
import ErrorBoundary from './ErrorBoundary'
import AuthProvider from './AuthProvider';
import InteractionsView from './views/InteractionsView';
import HistoryView from './views/HistoryView';
import VideoDetailView from './views/VideoDetailView';
import UsersView from './views/UsersView';

const App = () => {
    return (
        <AuthProvider>
            <Router basename="/">
                <OnRouteChange/>
                <ErrorBoundary>
                    <div className="app">
                        <ModalProvider>
                            <Switch>
                                <Route path={routes.login}>
                                    <LoginView/>
                                </Route>
                                <Route path={routes.reset}>
                                    <ResetView/>
                                </Route>
                                <PrivateRoute path={routes.dashboard}>
                                    <Layout>
                                        <DashboardView/>
                                    </Layout>
                                </PrivateRoute>
                                <PrivateRoute path={routes.scenario()}>
                                    <Layout>
                                        <ScenarioView/>
                                    </Layout>
                                </PrivateRoute>
                                <PrivateRoute path={routes.scenarios}>
                                    <Layout>
                                        <ScenariosView/>
                                    </Layout>
                                </PrivateRoute>
                                <PrivateRoute exact path={routes.reports}>
                                    <Layout>
                                        <ReportsView/>
                                    </Layout>
                                </PrivateRoute>
                                <PrivateRoute path={routes.users}>
                                    <Layout>
                                        <UsersView />
                                    </Layout>
                                </PrivateRoute>
                                <PrivateRoute path={routes.settings}>
                                    <Layout>
                                        <SettingsView/>
                                    </Layout>
                                </PrivateRoute>
                                <PrivateRoute path={routes.video()}>
                                    <Layout>
                                        <VideoDetailView />
                                    </Layout>
                                </PrivateRoute>
                                <PrivateRoute path={routes.history}>
                                    <Layout>
                                        <HistoryView />
                                    </Layout>
                                </PrivateRoute>
                                <PrivateRoute path={routes.interactions}>
                                    <Layout>
                                        <InteractionsView />
                                    </Layout>
                                </PrivateRoute>
                                <PrivateRoute path={routes.logging}>
                                    <Layout>
                                        <LoggingView/>
                                    </Layout>
                                </PrivateRoute>
                                <Route path="*">
                                    <PageNotFoundView/>
                                </Route>
                            </Switch>
                        </ModalProvider>
                    </div>
                </ErrorBoundary>
            </Router>
        </AuthProvider>
    )
};

export default App;
